module.exports = __webpack_public_path__ + "img/icon-tours-black.0e310b94.svg";